var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSettings = function SvgSettings(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)",
    stroke: "currentColor",
    strokeWidth: 1.7,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 2.739
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 10.291v-2.68l-1.565-.114a1.663 1.663 0 0 1-1.417-1.025v-.02a1.667 1.667 0 0 1 .278-1.729l1.025-1.174-1.905-1.91-1.174 1.026a1.667 1.667 0 0 1-1.73.278h-.02c-.58-.23-.977-.771-1.025-1.393L10.338 0h-2.68l-.114 1.542A1.647 1.647 0 0 1 6.52 2.947a1.667 1.667 0 0 1-1.73-.278L3.617 1.643l-1.93 1.879 1.026 1.174c.412.477.52 1.147.278 1.73a1.663 1.663 0 0 1-1.425 1.071L0 7.611v2.68l1.565.118a1.663 1.663 0 0 1 1.417 1.025v.02a1.667 1.667 0 0 1-.278 1.729l-1.025 1.174 1.894 1.894 1.174-1.025a1.667 1.667 0 0 1 1.73-.278h.019c.585.25.981.808 1.025 1.444L7.658 18h2.68l.114-1.585a1.683 1.683 0 0 1 1.025-1.428h.02a1.667 1.667 0 0 1 1.73.274l1.173 1.021 1.894-1.898-1.025-1.174a1.667 1.667 0 0 1-.278-1.73v-.019a1.663 1.663 0 0 1 1.444-1.052L18 10.29Z"
  }))));
};
export default SvgSettings;